import { createAction, props } from '@ngrx/store'
import { TeamHolder } from '@pages/team/models/team.models'
import { MetricMap } from '@core/models/metric.models'
import { PlayerHolder } from '@core/models/player.models'
import { Match } from '@core/models/match.models'

export const setMetricFinderMetrics = createAction('[MetricFinder] set metrics', props<{ metrics: MetricMap }>())
export const setMetricFinderHolder = createAction(
  '[MetricFinder] set metric holder',
  props<{ metricHolder: TeamHolder | PlayerHolder | Match }>()
)
export const setMetricFinderLoader = createAction('[MetricFinder] set metric loader', props<{ loading: boolean }>())
export const purgeMetricFinderMetrics = createAction('[MetricFinder] purge metrics')
